import { withRouter } from "react-router";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";

import { SeoRenderer } from "../../../common/helpers/seo";

import { post } from "../../actions/general";
import { editUser } from "../../store/user/actions";
import { IStateTree } from "../../store/interfaces";
import { IUser } from "../../store/user/models";

import loadableComponent from "./loadable";

const mapStateToProps = ({ user }: IStateTree) => ({
    user: user as IUser,
});

const mapDispatchToProps = { post, editUser };

export default {
    component: withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(loadableComponent))),
    renderSeo: (store: any, allMessage: {[key: string]: string}, lang: string) => {
        SeoRenderer({ title: allMessage["signup.title"], allMessage, lang });
    },
};
